import { apiSlice } from '../apiSlice';
import axios from '../../utils/axios';



export const tags = {};

const configApi = apiSlice
  .enhanceEndpoints({ addTagTypes: Object.values(tags) })
  .injectEndpoints({
    endpoints: (build) => ({

      getConfigAll: build.query({
        queryFn: async () => {
          try {
            const response = await axios({
              url: `${baseURL}/app-config`,
              method: 'GET',
            });
            return { data: response.data };
          } catch (error) {
            console.error(error.response);
            return { error };
          }
        },
        providesTags: [],
      }),


      getConfigLandingPage: build.query({
        queryFn: async () => {
          try {
            const response = await axios({
              url: `${baseURL}/app-config/landing-page`,
              method: 'GET',
            });
            return { data: response.data };
          } catch (error) {
            console.error(error.response);
            return { error };
          }
        },
        providesTags: [],
      }),



      getConfigESign: build.query({
        queryFn: async () => {
          try {
            const response = await axios({
              url: `${baseURL}/app-config/e-sign`,
              method: 'GET',
            });
            return { data: response.data };
          } catch (error) {
            console.error(error.response);
            return { error };
          }
        },
        providesTags: [],
      }),
    }),
  });

export const {
  useGetConfigAllQuery,
  useGetConfigLandingPageQuery,
  useGetConfigESignQuery,
} = configApi;
